import { Box, useTheme, useMediaQuery } from "@mui/material";

import AgentDetailDesktop from "./AgentDetailDesktop";
import AgentDetailMobile from "./AgentDetailMobile";

export default function AgentDetail() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // return isMobile ? <HelpfaqMobile /> : <HelpfaqDesktop />;
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      {isMobile ? <AgentDetailMobile /> : <AgentDetailDesktop />}
    </Box>
  );
}
